import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'button-section',
  templateUrl: './button-section.component.html',
  styleUrls: ['./button-section.component.scss'],
})
export class ButtonSectionComponent implements OnInit {
  @Input() btn1Boolean: boolean = true;
  @Input() btn2Boolean: boolean = true;
  @Input() btn3Boolean: boolean = true;
  @Input() btn4Boolean: boolean = true;
  @Input() btn1Disabled: boolean = false;
  @Input() btn2Disabled: boolean = false;
  @Input() btn3Disabled: boolean = false;
  @Input() btn4Disabled: boolean = false;

  @Input() btn1Label: string;
  @Input() btn2Label: string;
  @Input() btn3Label: string;
  @Input() btn4Label: string;
  @Input() btn1Color: string= 'btn-azul';
  @Input() btn2Color: string= 'btn-azul';
  @Input() btn3Color: string= 'btn-azul';
  @Input() btn4Color: string= 'btn-azul';

  @Input() btn1Icon: string;
  @Input() btn2Icon: string;
  @Input() btn3Icon: string;
  @Input() btn4Icon: string;

  @Output() btn1Event = new EventEmitter<any>();
  @Output() btn2Event = new EventEmitter<any>();
  @Output() btn3Event = new EventEmitter<any>();
  @Output() btn4Event = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
